import { RequestBase } from '@/api/base'

export function loginPerson(params) {
  return RequestBase({
    url: '/user/userLogin',
    method: 'post',
    data: params
  })
}

export function loginGroup(params) {
  return RequestBase({
    url: '/club/clubLogin',
    method: 'post',
    data: params
  })
}

export function loginUmpire(params) {
  return RequestBase({
    url: '/umpire/umpireLogin',
    method: 'post',
    data: params
  })
}

export function loginCoach(params) {
  return RequestBase({
    url: '/coach/coachLogin',
    method: 'post',
    data: params
  })
}

export function getInfoPerson(params) {
  return RequestBase({
    url: '/user/userGetInfo',
    method: 'post',
    data: params
  })
}

export function getInfoUmpire(params) {
  return RequestBase({
    url: 'umpire/umpireGetInfo',
    method: 'post',
    data: params
  })
}

export function getInfoCoach(params) {
  return RequestBase({
    url: 'coach/coachGetInfo',
    method: 'post',
    data: params
  })
}

export function getInfoClub(params) {
  return RequestBase({
    url: '/club/clubGetInfo',
    method: 'post',
    data: params
  })
}

// 发短信 "smsType":2//短信类型1,注册;2,修改密码
export function sendMessage(params) {
  return RequestBase({
    url: '/sms/sendSms7833838474457078',
    method: 'post',
    data: params
  })
}

export function getUserClub(params) {
    return RequestBase({
        url: '/club/getUserClub',
        method: 'post',
        data: params
    })
}



// WEBPACK FOOTER //
// ./src/api/login.js